import Logs from '@pages/Logs/Logs'

export default Logs;
